import { Ignore } from '@master/annotation/Ignore'
import { IDateService } from '@master/services/IDateService'
import { inject } from 'inversify-props'
import { ClientInfoBase } from './ClientInfoBase'

export const ScreeningTypeOptions = [
  { label: '', value: '' },
  { label: 'World Check', value: 'World Check' }
]
export const OutcomeOptions = [
  { label: '', value: '' },
  { label: 'Standard', value: 'standard' },
  { label: 'PEP', value: 'PEP' },
  { label: 'HRC', value: 'HRC' },
  { label: 'High Risk Jurisdiction (from high risk countries)', value: 'High Risk Jurisdiction' },
  { label: 'Others', value: 'Others' }
]
export const RiskAssessmentOptions = [
  { label: '', value: '' },
  { label: 'Low Risk Person', value: 'Low Risk Person' },
  { label: 'High Risk Person', value: 'High Risk Person' }
]
export const DDTypeOptions = [
  { label: '', value: '' },
  { label: 'Simplified', value: 'Simplified' },
  { label: 'Enchanced', value: 'Enchanced' },
  { label: 'Rejected', value: 'Rejected' },
  { label: 'None', value: 'None' }
]
export class ClientScreening extends ClientInfoBase {
  @Ignore()
  @inject()
  protected dateService: IDateService

  @Ignore()
  clientOid = undefined

  @Ignore()
  screeningOid = undefined

  ddTypeConducted = undefined
  outcome = undefined
  performedBy = undefined
  remarks = undefined
  riskAssessment = undefined
  screeningDate = undefined
  type = undefined

  @Ignore()
  get screenDateDisplay () {
    return this.dateService.format(Number(this.screeningDate), 'YYYY-MM-DD')
  }
}
